import { Component } from '@angular/core'
import { CellComponent } from '@spartacus/organization/administration/components'

@Component({
    selector: 'eb-product-variants-table-default',
    templateUrl: './eb-product-variants-table-default.component.html',
    standalone: false
})
export class EbProductVariantsTableDefaultComponent extends CellComponent {}
